import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import "./QuickBooksOnlineConnectCustomersModal.scss";
import IQBOOnConnectAllCustomersDTO from "../../../../models/DTO/IQBOOnConnectAllCustomersDTO";
import OwProgressBar from "../../../shared/OwProgressBar/OwProgressBar";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import UserContext from "../../../../contexts/UserContext";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IQBOConnectAllCustomersDTO from "../../../../models/DTO/IQBOConnectAllCustomersDTO";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IQBOConnectAllCustomersProgressDTO from "../../../../models/DTO/IQBOConnectAllCustomersProgressDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import ISupplierModel from "../../../../models/ISupplierModel";
import INotification from "../../../../models/INotification";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import SupplierContext from "../../../../contexts/SupplierContext";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

export const QuickBooksOnlineConnectCustomersModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const closeModal = () => {
        props.closeModalFn();
    };

    const [isProcessing, setIsProcessing] = useState(false);
    const [totalCustomers, setTotalCustomers] = useState(0);
    const [totalProcessed, setTotalProcessed] = useState(0);
    const [totalConnected, setTotalConnected] = useState(0);
    const [matchTo, setMatchTo] = useState<"display_name" | "fully_qualified_name" | "company_name">("display_name");

    const matchToOptions = [
        { title: "Display Name", value: "display_name" },
        { title: "Fully Qualified Name", value: "fully_qualified_name" },
        { title: "Company Name", value: "company_name" },
    ];

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;
    };

    useEffect(() => {
        props.socket.on(EndpointsEnum.QBOOnConnectAllCustomers, onConnectAllCustomers);
        props.socket.on(EndpointsEnum.QBOConnectAllCustomersProgress, connectAllCustomersProgress);

        return () => {
            props.socket.removeListener(EndpointsEnum.QBOOnConnectAllCustomers, onConnectAllCustomers);
            props.socket.removeListener(EndpointsEnum.QBOConnectAllCustomersProgress, connectAllCustomersProgress);
        };
    }, []);

    const connectAllCustomers = () => {
        const payload: IQBOConnectAllCustomersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            matchTo,
        };

        props.socket.emit(EndpointsEnum.QBOConnectAllCustomers, payload);

        setIsProcessing(true);
    };

    const onConnectAllCustomers = (data: IQBOOnConnectAllCustomersDTO) => {
        setTotalProcessed(data.totalProcessed);
        setTotalConnected(data.totalConnected);

        const notification: INotification = {
            message: "successfully_connected_all_customers",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);
    };

    const connectAllCustomersProgress = (data: IQBOConnectAllCustomersProgressDTO) => {
        setTotalCustomers(data.totalCustomers);
        setTotalProcessed(data.totalProcessed);
    };

    return (
        <div className={"QuickBooksOnlineConnectCustomersModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-exchange"} title={"connect_customers"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            {isProcessing ? (
                <div>
                    <OwProgressBar
                        currentPercent={(totalProcessed / totalCustomers) * 100}
                        showTitleChunk={true}
                        titleChunkCurrent={totalProcessed}
                        titleChunkTotal={totalCustomers}
                    />
                    <div className={"mt-5"}>
                        <OwLabel title={"total_connected"} postText={":"} /> {totalConnected}
                    </div>
                </div>
            ) : (
                <div>
                    <OwLabel title={"match_name_to"} />
                    <OwSelectOption
                        name={"match_name_to"}
                        options={matchToOptions}
                        fn={handleChange}
                        titleProp={"title"}
                        valueProp={"value"}
                        selectedOption={matchTo}
                        hasSelectedOptionProp={false}
                    />
                    <div className={"mt-3"}>
                        <OwButton title={"start"} fn={connectAllCustomers} active={isProcessing} disableOnActive={true} />
                    </div>
                </div>
            )}
        </div>
    );
};
